// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_AcceptRefundResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for POST /payroll/accept_refund/{id}
 *
 * Dados shape: Object with refund and despesa_id.
 */
import type { Payroll_RefundRow } from './Payroll_RefundRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Payroll_AcceptRefundResponseDados {
refund: Payroll_RefundRow
despesa_id: number
}

export type Payroll_AcceptRefundResponse = ApiResponse<Payroll_AcceptRefundResponseDados>;

registerResponseContract('Payroll_AcceptRefundResponse', {
  refund: {
    type: 'object',
    required: true,
    fields: {
      id:                    { type: 'number',  required: true },
      pays_to:               { type: 'string',  required: true },
      franchise_id:          { type: 'number',  required: true },
      title:                 { type: 'string',  required: true },
      description:           { type: 'string',  required: false },
      amount:                { type: 'string',  required: true },
      expense_date:          { type: 'string',  required: true },
      blob_name:             { type: 'string',  required: true },
      status:                { type: 'number',  required: true },
      accepted_at:           { type: 'string',  required: false },
      accepted_by:           { type: 'string',  required: false },
      declined_at:           { type: 'string',  required: false },
      declined_by:           { type: 'string',  required: false },
      decline_reason:        { type: 'string',  required: false },
      despesa_id:            { type: 'number',  required: false },
      payroll_period_id:     { type: 'number',  required: false },
      created_at:            { type: 'string',  required: true },
      created_by:            { type: 'string',  required: true },
      updated_at:            { type: 'string',  required: false },
      request_date:          { type: 'string',  required: false },
      file_url:              { type: 'string',  required: false },
      linked_despesa_status: { type: 'number',  required: false },
    },
  },
  despesa_id: { type: 'number',  required: true },
})
